import React from 'react';
import uniqueId from 'lodash/uniqueId';
import classNames from 'classnames';
import omit from 'lodash/omit';
import RcSelect, { Option } from 'rc-select';
import './rc-select.scss';
import './styles.scss';


class Select extends React.Component {
  constructor (props) {
    super(props);
  };

  onChange = (value, option) => {
    if (!this.props.allowClear && !value) return;
    this.props.onChange(value || "");
  };

  render() {
    const newProps = omit(this.props, ['options']);

    // convert all values to string
    let value = this.props.value;
    value = value ? value + '' : [];

    const options = [];
    this.props.options.forEach((option) => {
      option.value += '';
      options.push(option);
    })

    let getPopupContainer = this.props.getPopupContainer;
    if (!getPopupContainer) getPopupContainer = () => document.querySelector('.ov-app-reperks-widget');

    return (
      <RcSelect
        {...newProps}
        value={value}
        multiple={false}
        onChange={this.onChange}
        prefixCls="ov-select"
        optionLabelProp="children"
        optionFilterProp="text"
        notFoundContent="No results found"
        dropdownAlign={{ offset: [0, -1] }}
        getPopupContainer={getPopupContainer}
      >
        {options.map((option) =>
          <Option
            key={option.value}
            title={option.label}
            text={option.label}
          >
            {option.label}
          </Option>
        )}
      </RcSelect>
    )
  }
}

Select.propTypes = RcSelect.propTypes;
Select.defaultProps = RcSelect.defaultProps;
Select.defaultProps.allowClear = true;



class MultiSelect extends React.Component {
  constructor (props) {
    super(props);
  };

  onChange = (values, options) => {
    this.props.onChange(values.map((value) => value.key));
  };

  render() {
    const newProps = omit(this.props, ['options']);
    const className = classNames("multiple", this.props.className);

    // convert all values to string
    const selectedValues = this.props.value.map((row) => row + '');
    const options = [];
    this.props.options.forEach((option) => {
      option.value += '';
      options.push(option);
    })

    // exclude selected values
    const selectableOptions = options.filter((option) => !selectedValues.includes(option.value));

    // get selected options
    const values = [];
    const selectedOptions = options.filter((option) => selectedValues.includes(option.value));
    selectedOptions.forEach((option) => {
      values.push({key: option.value, label: option.label});
    })

    let getPopupContainer = this.props.getPopupContainer;
    if (!getPopupContainer) getPopupContainer = () => document.querySelector('.ov-app-reperks-widget');

    return (
      <RcSelect
        {...newProps}
        className={className}
        value={values}
        multiple={true}
        allowClear={false}
        labelInValue={true}
        onChange={this.onChange}
        prefixCls="ov-select"
        optionLabelProp="children"
        optionFilterProp="text"
        notFoundContent="No results found"
        dropdownAlign={{ offset: [0, -1] }}
        getPopupContainer={getPopupContainer}
      >
        {selectableOptions.map((option) =>
          <Option
            key={option.value}
            title={option.label}
            text={option.label}
          >
            {option.label}
          </Option>
        )}
      </RcSelect>
    )
  }
}

MultiSelect.propTypes = RcSelect.propTypes;
MultiSelect.defaultProps = RcSelect.defaultProps;

export { Select, MultiSelect };
